import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { ContentfulModules } from '../../helpers/modules';
import { Tabs as SparkTabs, TabPanel, TabPanels, TabList, TabButton } from '@uswitch/spark';
import { useEntities } from '@uswitch/ev-utils/context/selectors';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var Tabs = function Tabs(_ref) {
  var _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? [] : _ref$tabs;

  var _tabs$reduce = tabs.reduce(function (result, _ref2, index) {
    var content = _ref2.content,
        title = _ref2.title;
    return {
      buttons: [].concat(_toConsumableArray(result.buttons), [_jsx(TabButton, {
        open: index === 0,
        children: title
      }, index)]),
      panels: [].concat(_toConsumableArray(result.panels), [_jsx(TabPanel, {
        open: index === 0,
        children: _jsx(ContentfulModules, {
          modules: [content]
        })
      }, index)])
    };
  }, {
    buttons: [],
    panels: []
  }),
      buttons = _tabs$reduce.buttons,
      panels = _tabs$reduce.panels;

  return _jsxs(SparkTabs, {
    sx: {
      py: 0
    },
    children: [_jsx(TabList, {
      children: buttons
    }), _jsx(TabPanels, {
      children: panels
    })]
  });
};

var TabsConnected = function TabsConnected(_ref3) {
  var entries = _ref3.entries,
      heading = _ref3.heading;
  var tabs = useEntities(entries);
  return _jsx(Tabs, {
    tabs: tabs,
    heading: heading
  });
};

export default TabsConnected;
//# sourceMappingURL=collection-tabs.js.map